import React from 'react';
import styled, { keyframes } from 'styled-components';
import { 
  Container, 
  PageContainer, 
  PageHeader, 
  PageTitle 
} from '../../styles/components';
import { glassDeep, glassHover } from '../../styles/components/common/glassmorphism';
import StudentProfile from '../../components/proStudent/StudentProfile';

// Animation keyframes
const titleGlow = keyframes`
  0% { text-shadow: 0 0 10px rgba(99, 102, 241, 0.5), 0 0 20px rgba(99, 102, 241, 0.3); }
  50% { text-shadow: 0 0 20px rgba(99, 102, 241, 0.8), 0 0 30px rgba(99, 102, 241, 0.5); }
  100% { text-shadow: 0 0 10px rgba(99, 102, 241, 0.5), 0 0 20px rgba(99, 102, 241, 0.3); }
`;

const floatAnimation = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
  100% { transform: translateY(0px); }
`;

// Styled components
const StyledPageContainer = styled(PageContainer)`
  position: relative;
  overflow: hidden;
  min-height: unset;
  padding: 2rem 0;
`;

const GlowingPageTitle = styled(PageTitle)`
  color: rgba(255, 255, 255, 0.95);
  position: relative;
  animation: ${titleGlow} 4s infinite ease-in-out, ${floatAnimation} 6s infinite ease-in-out;
  letter-spacing: 1px;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 0;
    width: 60px;
    height: 2px;
    background: linear-gradient(90deg, rgba(99, 102, 241, 0.8), transparent);
    border-radius: 1px;
  }
`;

const SpaceBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
  background-image: 
    radial-gradient(1px 1px at 5% 5%, rgba(255, 255, 255, 0.6) 1px, transparent 0),
    radial-gradient(1px 1px at 25% 20%, rgba(255, 255, 255, 0.6) 1px, transparent 0),
    radial-gradient(1px 1px at 50% 5%, rgba(255, 255, 255, 0.6) 1px, transparent 0),
    radial-gradient(1px 1px at 75% 25%, rgba(255, 255, 255, 0.6) 1px, transparent 0),
    radial-gradient(1px 1px at 95% 15%, rgba(255, 255, 255, 0.6) 1px, transparent 0),
    radial-gradient(1px 1px at 10% 40%, rgba(255, 255, 255, 0.6) 1px, transparent 0),
    radial-gradient(1px 1px at 30% 65%, rgba(255, 255, 255, 0.6) 1px, transparent 0),
    radial-gradient(1px 1px at 55% 45%, rgba(255, 255, 255, 0.6) 1px, transparent 0),
    radial-gradient(1px 1px at 80% 70%, rgba(255, 255, 255, 0.6) 1px, transparent 0),
    radial-gradient(1px 1px at 90% 55%, rgba(255, 255, 255, 0.6) 1px, transparent 0),
    radial-gradient(1px 1px at 15% 80%, rgba(255, 255, 255, 0.6) 1px, transparent 0),
    radial-gradient(1px 1px at 35% 95%, rgba(255, 255, 255, 0.6) 1px, transparent 0),
    radial-gradient(1px 1px at 60% 85%, rgba(255, 255, 255, 0.6) 1px, transparent 0),
    radial-gradient(1px 1px at 85% 90%, rgba(255, 255, 255, 0.6) 1px, transparent 0),
    radial-gradient(1px 1px at 95% 80%, rgba(255, 255, 255, 0.6) 1px, transparent 0);
  opacity: 0.3;
`;

const ProfileContainer = styled.div`
  ${glassDeep}
  border-radius: 16px;
  padding: 2rem;
  margin-top: 2rem;
  color: rgba(255, 255, 255, 0.9);
  box-shadow: 0 8px 32px rgba(31, 38, 135, 0.15);
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 12px 40px rgba(31, 38, 135, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.2);
  }
`;

const ProfilePage = () => {
  return (
    <StyledPageContainer>
      <SpaceBackground />
      <Container>
        <PageHeader>
          <GlowingPageTitle>Student Profile</GlowingPageTitle>
        </PageHeader>
        
        <ProfileContainer>
          <StudentProfile defaultTab="experience" isProStudent={true} />
        </ProfileContainer>
      </Container>
    </StyledPageContainer>
  );
};

export default ProfilePage;